import http from "./Http";

export default {
    getFluxoCaixaGerencialAnaliticoDataGrid: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/analiticoDataGrid', data)
    },
    getSituacaoEmpresaMestre: function() {
        return http.get("./api/financeiro/fluxocaixagerencial/situacaoEmpresaMestre");
    },
    postPerfilGerenciais: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/postPerfilGerenciais', data)
    },
    deletePerfilGerenciais: function (handle) {
        return http.post('./api/financeiro/fluxocaixagerencial/deletePerfilGerenciais/' + handle)
    },
    getPerfilGerenciais: function (handle) {
        return http.get('./api/financeiro/fluxocaixagerencial/getPerfilGerenciais/' + handle)
    },
    // Handle + nome dos itens de um lookup do Filtro avancado. O perfil grava so os
    // handles; sem o nome o select2 nao tem como repintar a selecao ao carregar o perfil.
    getDescricoesLookup: function (entityName, handles) {
        return http.post('./api/financeiro/fluxocaixagerencial/descricoesLookup', { entityName: entityName, handles: handles })
    },
    getFluxoCaixaGerencialSaldosBancarios: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/saldosBancarios', data)
    },
    // Rota da tela: pivot e saldos numa requisicao so. Em paralelo elas serializavam no lock
    // de sessao do WES e dividiam o mesmo limite de 120s do gateway.
    getFluxoCaixaGerencialPivotGridComSaldos: function (data) {
        return http.post('./api/financeiro/fluxocaixagerencial/pivotgridComSaldos', data)
    }
}
